import React, { useCallback, useState } from 'react';
import type { Partner, PartnerProfile, PartnerReport } from '../../../types/partners';
import { trackEvent } from '../../../utils/analytics';
import { Reveal } from '../../ui/Reveal';
import { ReportCard } from './ReportCard';
import { ReportPreviewModal } from './ReportPreviewModal';
type Props = {
  partner: Partner;
  reports: NonNullable<PartnerProfile['reports']>;
};
export function PartnerReportsSection({
  partner,
  reports
}: Props) {
  const [active, setActive] = useState<PartnerReport | null>(null);
  const openPreview = (report: PartnerReport) => {
    setActive(report);
    trackEvent('partner_report_preview', {
      partner_id: partner.id,
      partner_name: partner.name,
      report_type: report.id
    });
  };
  const close = useCallback(() => setActive(null), []);
  return <section id="reports" aria-labelledby="reports-heading" className="scroll-mt-24 border-b border-hairline-soft bg-ink" data-id="element-678" data-mp="2py496yqt4c4m">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-679" data-mp="2kyrpgmv8fl69">
        <Reveal className="max-w-3xl" data-id="element-680" data-mp="3rs93h21sqdry">
          <p className="text-[11px] font-semibold uppercase tracking-[0.09em] text-[color:var(--pa)]" data-id="element-681" data-mp="3rr7s0wgvbp9p">{reports.eyebrow}</p>
          <h2 id="reports-heading" className="sf-display mt-4 text-balance text-[32px] leading-[1.04] text-text-primary sm:text-[44px]" data-id="element-682" data-mp="5dpmqypcmmib">
            {reports.headline}
          </h2>
          {reports.intro ? <p className="mt-4 text-[15px] leading-relaxed text-text-secondary" data-id="element-683" data-mp="38ug2446tmbwo">{reports.intro}</p> : null}
        </Reveal>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-684" data-mp="3dsr9875qe8b7">
          {reports.items.map((report, index) => <Reveal key={report.id} as="li" delay={index * 0.04} data-id="element-685" data-mp="3hucvgj45nyy2" data-mpi={index}>
              <ReportCard partner={partner} report={report} index={index} onPreview={openPreview} data-id="element-686" data-mp="3muqs750b3mgs" />
            </Reveal>)}
        </ul>
      </div>
      <ReportPreviewModal partner={partner} report={active} onClose={close} data-id="element-687" data-mp="x6zvgadwy7e7" />
    </section>;
}